import { Outlet } from "react-router-dom";
import  Sidebar  from './Sidebar';
import UpdateBanner from './UpdateBanner';

const Layout = () => {
	return (
		<>
      <div id="main-container">
        <Sidebar />
        <div className="wrapper">
	      	<Outlet />
	      </div>
      </div>
      <UpdateBanner />
		</>
	);
};

export default Layout;